module.exports = __webpack_public_path__ + "static/media/icon-manage-class-student-list-plan-school.2467c838.svg";